<template>
<svg viewBox="0 0 17 17" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-YaoShi`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.43661 8.64603C7.10328 8.1127 6.96995 7.5127 6.96995 6.84603C6.96995 4.97936 8.43661 3.5127 10.3033 3.5127C12.1699 3.5127 13.6366 4.97936 13.6366 6.84603C13.6366 8.7127 12.1699 10.1794 10.3033 10.1794C9.56995 10.1794 8.96995 9.97936 8.36995 9.57936L6.83661 11.1127L7.56995 11.846L6.63661 12.7794L5.90328 12.046L5.43661 12.5127L6.16995 13.246L5.23661 14.1794L3.56995 12.5127L7.43661 8.64603ZM10.3033 4.84603C9.16995 4.84603 8.30328 5.7127 8.30328 6.84603C8.30328 7.97936 9.16995 8.84603 10.3033 8.84603C11.4366 8.84603 12.3033 7.97936 12.3033 6.84603C12.3033 5.7127 11.3699 4.84603 10.3033 4.84603Z"/></svg>
</template>
<script>

export default {
  name: 'IconYaoShi',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
